import axios from "axios";

export default {
	// 查询地址详情
	geo(address) {
		return axios.get(`https://restapi.amap.com/v3/geocode/geo?key=a6040dc53c96e1e7c898e5084df1e94a&address=${address}`);
	},
	district(adcode) {
		return axios.get(`https://restapi.amap.com/v3/config/district?key=a6040dc53c96e1e7c898e5084df1e94a&extensions=all&subdistrict=0&keywords=${adcode}`);
	},
	
	
};
